"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUERY_KEY_PREFERENCE = exports.usePreference = exports.useUserPreferences = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_query_1 = require("react-query");
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const ObjectivesClient_1 = require("src/client/ObjectivesClient");
const QUERY_KEY_PREFERENCE = 'preference-filter';
exports.QUERY_KEY_PREFERENCE = QUERY_KEY_PREFERENCE;
const usePreference = ({ module, page, section, cycleId }) => {
    const queryClient = (0, react_query_1.useQueryClient)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const queryData = queryClient.getQueryData(QUERY_KEY_PREFERENCE);
    const data = (queryData === null || queryData === void 0 ? void 0 : queryData.data) || [];
    const isSuccess = (queryData === null || queryData === void 0 ? void 0 : queryData.isSuccess) || false;
    const getCondition = (data) => {
        var _a;
        return (data.module == module &&
            data.page == page &&
            data.section == section &&
            (cycleId ? ((_a = data === null || data === void 0 ? void 0 : data.cycle) === null || _a === void 0 ? void 0 : _a.id) == cycleId : true));
    };
    const dataResult = data.find((data) => getCondition(data)) || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const saveFilter = (filter) => __awaiter(void 0, void 0, void 0, function* () {
        if ((0, isEmpty_1.default)(filter))
            return;
        const params = Object.assign(Object.assign({}, filter), { module,
            page,
            section });
        const { data, isSuccess } = yield (module === 'formal_review'
            ? (0, ObjectivesClient_1.updateFormalReviewPreferencesFilter)(params)
            : (0, ObjectivesClient_1.updatePreferencesFilter)(params));
        if (!isSuccess && !data)
            return;
        const { data: draft } = queryClient.getQueryData(QUERY_KEY_PREFERENCE);
        const draftData = (draft === null || draft === void 0 ? void 0 : draft.slice()) || [];
        const edittedIndex = draftData.findIndex((data) => getCondition(data));
        if (edittedIndex > -1) {
            draftData[edittedIndex] = data;
        }
        else {
            draftData.push(data);
        }
        queryClient.setQueryData(QUERY_KEY_PREFERENCE, (prevData) => (Object.assign(Object.assign({}, prevData), { data: draftData })));
    });
    return {
        data: dataResult ? Object.assign(Object.assign({}, dataResult), { data: (dataResult === null || dataResult === void 0 ? void 0 : dataResult.data) || [] }) : null,
        isLoaded: isSuccess,
        saveFilter
    };
};
exports.usePreference = usePreference;
const useUserPreferences = (queryKey, queryConfig) => {
    const queryFn = () => {
        return (0, ObjectivesClient_1.getPreferencesFilter)();
    };
    return (0, react_query_1.useQuery)(queryKey, queryFn, queryConfig);
};
exports.useUserPreferences = useUserPreferences;
